import React from "react";

const PermissionMessage = ({ page }) => {
  return <div>you don't have permission to access {page} page</div>;
};

export default PermissionMessage;
